import React, { useCallback, useMemo } from 'react';

import { getMetaContent } from '../../lib/meta';

import InputWithSuffix from './InputWithSuffix';

const PROTOCOL_PATTERN = /^https?:\/\//i;

export function cleanSlug(raw, host) {
  if (!raw) return '';
  let stripped = raw.trim().replace(PROTOCOL_PATTERN, '');
  if (host) {
    const escapedHost = host.replace(/\./g, '\\.');
    stripped = stripped.replace(new RegExp(`(?:\\.${escapedHost})+$`, 'i'), '');
  }
  // normalize to match Workspace model slug validation: /\A[a-z0-9\-]+\z/
  // e.g. "Foo.Google.com" → "foo-google-com"
  return stripped
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

const WorkspaceSlugInput = ({ value, onChange, ...inputProps }) => {
  const defaultHost = useMemo(() => getMetaContent('env:default_host'), []);

  const clean = useCallback((raw) => cleanSlug(raw, defaultHost), [defaultHost]);

  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const handleBlur = useCallback(() => {
    onChange(clean(value));
  }, [onChange, clean, value]);

  return (
    <InputWithSuffix
      {...inputProps}
      type="text"
      placeholder="example"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      suffix={`.${defaultHost}`}
    />
  );
};

export default WorkspaceSlugInput;
